import type { useNavigate } from "react-router-dom";

import type { FormContextData } from "@thalamos/aspire-common";

import { api } from "../../../../api.js";
import { routeFns } from "../../../../routePaths.js";
import { renderErrorToast } from "~/components/design-system/index.js";

export async function createDraftAndHandleResult(
  newDraftId: string,
  formId: string,
  navigateFn: ReturnType<typeof useNavigate>,
  formContext: Omit<FormContextData, "patient">,
) {
  const result = await api.drafts.create(newDraftId, {
    formId: formId,
  });

  if (result.status === 201) {
    navigateFn(routeFns.formDraftsComplete(newDraftId, formContext.patientId));
  } else {
    renderErrorToast({ message: "Failed to create draft" });
  }
}

// Resume-vs-create for a redo replacement draft. Returns the id of the current
// user's existing in-progress draft on the form (matching the backend's
// form+user+team dedup key in formDraftController.createDraft), or undefined when
// a fresh draft should be created. "Continue redo" used to always create a new
// draft, which the backend then rejected once one existed — leaving the user
// unable to get back into their draft (DEV-2415).
export function findResumableReplacementDraftId(
  form:
    | {
        allDrafts?: {
          id: string;
          status: string;
          ownerUserId: string;
          ownerTeamId: string;
        }[];
      }
    | undefined,
  userId: string,
  teamId: string | undefined,
): string | undefined {
  return form?.allDrafts?.find(
    (d) =>
      d.status === "in-progress" &&
      d.ownerUserId === userId &&
      d.ownerTeamId === teamId,
  )?.id;
}
